import React from "react";
import Footer from "../../components/Footer";
import NavLite from "../../components/NavLite";


function OurDifference() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
    <title>What Makes Us Different | Strategic Design & SEO for Women | Her Growth Co.</title>
    <meta
      name="description"
      content="At Her Growth Co, we combine design, content, and strategy to help women-led businesses scale confidently and sustainably."
    />
    <meta
      name="keywords"
      content="why choose Her Growth Co, female-led creative team, holistic approach to digital growth, women empowering women online, brand-first strategy, intuitive design for leaders, impact-driven SEO and design, authentic web presence building, unique agency for women-led brands"
    />

    <div>
<NavLite/>
      <div className="text-center items-center justify-center text-9xl mt-10">
     
        Coming Soon
        </div>
        <Footer />
     
    </div>
    </main>
  );
}

export default OurDifference